<template>
  <div class="pages">
    <!-- <el-pagination
      background
      @current-change='pageChange'      
      layout="prev, pager, next"
      :total="ctotal">
      123
    </el-pagination> :current-page.sync="cpage"-->

    <el-pagination
      @current-change="pageChange"
      @size-change="sizeChange"
      :current-page="mpage"
      :page-sizes="psize"
      :page-size="10"
      :layout="playout"
      :total="ctotal"
    ></el-pagination>
    <!--  -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // page: 1
      pname: "",
      mpage: 1
    };
  },
  computed: {
    psize() {
      if (this.pname == "equip") {
        return [10, 30, 50, 100];
      } else {
        return [];
      }
    },
    playout() {
      if (this.pname == "equip") {
        return "total, sizes, prev, pager, next";
      } else {
        return "total, prev, pager, next";
      }
    }
  },
  props: ["cpage", "ctotal", "config"],
  watch: {
    config(obj) {
      this.pname = obj.pname;      
      this.mpage = obj.page>0?obj.page:this.mpage      
      this.ctotal = 100
    },
    cpage (n) {      
      this.mpage = n
    },
    ctotal(n, o) {      
      if (n == 0 || o == 0) return;
      // if (o > n && n % this.$gRow == 0) {
      //   this.pageChange(n / this.$gRow);
      // }
      var isZero = n % this.$gRow == 0
      var newPage = n / this.$gRow
      // var upage = (isZero && this.$props.cpage>newPage)? newPage:this.$props.cpage
      var upage = (isZero && this.mpage>newPage)? newPage:this.mpage      
      this.pageChange(upage);      
    }
  },
  mounted () {
    
  },
  methods: {
    sizeChange(size) {
      // this.$props.cpage = 1;
      this.mpage = 1
      this.pageChange(1, size);
    },
    pageChange(page, size) {

      if (this.config.callback) {
        this.config.callback(page, size);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
